export default __webpack_public_path__ + "static/media/twitter.53f76af9.svg";